export default "__VITE_ASSET__CqSJ0FlK__"